import { gsap } from 'gsap';

export function psDragCursor() {
    const cursor = document.querySelector('.ps-drag-cursor');
    if (!cursor) return;

    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    gsap.set(cursor, { x: -200, y: -200, scale: 0, opacity: 0 });

    let visible = false;

    function isDraggable(target) {
        return !!target.closest('.swiper-wrapper') && !target.closest('.ps-videos-ticker');
    }

    document.addEventListener('mousemove', (e) => {
        // Position snaps tightly to cursor
        gsap.to(cursor, { x: e.clientX, y: e.clientY, duration: 0.15, ease: 'power1.out', overwrite: 'auto' });

        const over = isDraggable(e.target);
        if (over && !visible) {
            visible = true;
            gsap.to(cursor, { scale: 1, opacity: 1, duration: 0.35, ease: 'back.out(1.7)', overwrite: 'auto' });
        } else if (!over && visible) {
            visible = false;
            gsap.to(cursor, { scale: 0, opacity: 0, duration: 0.2, ease: 'power2.in', overwrite: 'auto' });
        }
    });

    document.addEventListener('mouseleave', () => {
        visible = false;
        gsap.to(cursor, { scale: 0, opacity: 0, duration: 0.2, overwrite: 'auto' });
    });
}
